import { Component, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { StorageService } from '@damofire/data-angular-commons';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { IfOnlineDirective } from '../directive/if-online.directive';
import { AutoUnsubscribe } from '../auto-unsubscribe.decorator';

const LNG_STORAGE_KEY = 'tt.lng';

@AutoUnsubscribe()
@Component({
  selector: 'app-lang-selector',
  templateUrl: './lang-selector.component.html',
  standalone: true,
  imports: [MatMenuModule, MatButtonModule, MatIconModule, IfOnlineDirective],
})
export class LangSelectorComponent implements OnInit {
  @Input()
  menuItem = true;

  nextLng: string;
  private langSub: Subscription;

  constructor(
    private readonly translate: TranslateService,
    private readonly storageService: StorageService,
  ) {}

  private static getOppositeLang(lang: string): string {
    return lang.toLocaleLowerCase() === 'en' ? 'fr' : 'en';
  }

  ngOnInit(): void {
    this.initUserLanguage();
  }

  private initUserLanguage(): void {
    this.langSub = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.nextLng = LangSelectorComponent.getOppositeLang(event.lang).toLocaleUpperCase();
      this.storageService.setItem(LNG_STORAGE_KEY, event.lang);
      moment.locale(event.lang);
    });

    moment.locale(this.translate.currentLang);
    this.nextLng = LangSelectorComponent.getOppositeLang(this.translate.currentLang || 'en').toLocaleUpperCase();
  }

  public toggleLang(): void {
    this.translate.use(this.nextLng.toLowerCase());
  }
}
